module.exports = __webpack_public_path__ + "static/media/bao1.b88c1c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/bao1.png
// module id = 391
// module chunks = 0